import * as Y from 'yjs';
import type { IAppInformation } from '../sessions/session/iframe/additional-apps.utils';

/** The Y.Doc map the Mario SDK's sync(json) writes to. */
const MARIO_JSON_ROOT = 'root';

export function hasYDocAccess(app: IAppInformation | undefined): boolean {
  return app?.marioAppConfig?.hasYDocAccess === true;
}

/** Whether a Yjs update only writes under the JSON `root` map, as the SDK's sync() does. */
export function touchesOnlyJsonRoot(update: Uint8Array): boolean {
  return Y.decodeUpdate(update).structs.every((struct) => {
    const parent = (struct as Y.Item).parent;
    return typeof parent !== 'string' || parent === MARIO_JSON_ROOT;
  });
}

export function canApplyMarioUpdate(app: IAppInformation | undefined, update: Uint8Array): boolean {
  return hasYDocAccess(app) || touchesOnlyJsonRoot(update);
}
